import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useEffect, useState } from 'react';
import { isAvailableForNotifications, requestNotificationPermission } from "../../utils";
export var useRequestPermission = function useRequestPermission() {
  var _useState = useState(isAvailableForNotifications()),
    _useState2 = _slicedToArray(_useState, 2),
    isGranted = _useState2[0],
    setIsGranted = _useState2[1];
  var requestBrowserNotificationsPermission = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var permission;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return requestNotificationPermission();
          case 2:
            permission = _context.sent;
            setIsGranted(permission === 'granted');
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function requestBrowserNotificationsPermission() {
      return _ref.apply(this, arguments);
    };
  }();
  useEffect(function () {
    // Смотрим есть ли разрешение на уведомления и если нужно запрашиваем его
    if (!isGranted) {
      void requestBrowserNotificationsPermission();
    }
  }, []);
  return isGranted;
};